export default {"src":"/_next/static/media/calendarTwo_24.930dab49.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};